import React from 'react';

export default function BriefingView({ briefing, loading }) {
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <div className="loading-text">Compass is preparing your daily briefing...</div>
      </div>
    );
  }

  if (!briefing) {
    return (
      <div className="briefing-container">
        <div className="briefing-headline">Briefing unavailable</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>
          Could not generate the daily briefing. Ensure integrations are connected and ANTHROPIC_API_KEY is set.
        </p>
      </div>
    );
  }

  return (
    <div className="briefing-container">
      <div className="briefing-date">{briefing.date || new Date().toLocaleDateString()}</div>
      <div className="briefing-headline">{briefing.headline}</div>

      {/* Prerequisite Status */}
      {briefing.prerequisiteStatus && (
        <div className="briefing-section">
          <h3>Prerequisite Status</h3>
          <div className="briefing-prereq-grid">
            {briefing.prerequisiteStatus.map((p, i) => (
              <div key={i} className="briefing-prereq-card">
                <h4>{p.name}</h4>
                <span className={`status-badge ${p.status}`}>{p.status.replace('-', ' ')}</span>
                <p>{p.evidence}</p>
                {p.nextAction && (
                  <p style={{ marginTop: 6, color: 'var(--brand-teal)', fontSize: 11 }}>
                    Next: {p.nextAction}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Today's Actions */}
      {briefing.todayActions && briefing.todayActions.length > 0 && (
        <div className="briefing-section">
          <h3>Do Today</h3>
          <ul className="briefing-list">
            {briefing.todayActions.map((a, i) => (
              <li key={i} className="action">
                <strong style={{ color: 'var(--text-primary)' }}>{a.action}</strong>
                <br />
                <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{a.why}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* What Moved */}
      {briefing.whatMoved && briefing.whatMoved.length > 0 && (
        <div className="briefing-section">
          <h3>What Moved</h3>
          <ul className="briefing-list">
            {briefing.whatMoved.map((item, i) => (
              <li key={i} className="moved">{typeof item === 'string' ? item : item.description || JSON.stringify(item)}</li>
            ))}
          </ul>
        </div>
      )}

      {/* What Stalled */}
      {briefing.whatStalled && briefing.whatStalled.length > 0 && (
        <div className="briefing-section">
          <h3>What Stalled</h3>
          <ul className="briefing-list">
            {briefing.whatStalled.map((item, i) => (
              <li key={i} className="stalled">{typeof item === 'string' ? item : item.description || JSON.stringify(item)}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Calendar Prep */}
      {briefing.calendarPrep && briefing.calendarPrep.length > 0 && (
        <div className="briefing-section">
          <h3>Meeting Prep</h3>
          <ul className="briefing-list">
            {briefing.calendarPrep.map((item, i) => (
              <li key={i}>{typeof item === 'string' ? item : item.description || JSON.stringify(item)}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Pipeline Snapshot */}
      {briefing.pipelineSnapshot && (
        <div className="briefing-section">
          <h3>Pipeline Snapshot</h3>
          <div className="briefing-snapshot">
            <SnapshotItem label="CCO Candidates" value={briefing.pipelineSnapshot.ccoCandidates} />
            <SnapshotItem label="Pilot Contacts" value={briefing.pipelineSnapshot.pilotContacts} />
            <SnapshotItem label="HADES Leads" value={briefing.pipelineSnapshot.hadesLeads} />
            <SnapshotItem label="Content Published" value={briefing.pipelineSnapshot.contentPublished} />
            <SnapshotItem label="n8n Health" value={briefing.pipelineSnapshot.n8nHealth} />
          </div>
        </div>
      )}
    </div>
  );
}

function SnapshotItem({ label, value }) {
  const display = value === undefined || value === null ? '—' : value;
  return (
    <div className="snapshot-item">
      <div className="value">{display}</div>
      <div className="label">{label}</div>
    </div>
  );
}
